import request from '@/utils/request'

export function openLogin(data) {
  return request({
    url: '/finance/wechat/open/login',
    method: 'post',
    data
  })
}

export function payJsapiOrg(data) {
  return request({
    url: '/finance/wechat/payJsapiOrg',
    method: 'post',
    data
  })
}

// 小程序支付

export function smallProgramPay(data) {
  return request({
    url: '/finance/wechat/smallProgramPay',
    method: 'post',
    data
  })
}
